import 'css-chunksrc/client/scenes/projectGroupCreation/styles.scss';export default {
  "title": "_title_1hqt7_1",
  "main": "_main_1hqt7_11",
  "buttons": "_buttons_1hqt7_15",
  "button": "_button_1hqt7_15"
};